export default "/shell-guide-small.780fdaf991ab3cb6ba3c46548af22511.svg";